import React from 'react'
import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import Heading from '@tiptap/extension-heading'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'

export default function Ckeditor(field) {
  const editor = useEditor({
    editable: !field.disabled,
    extensions: [
      StarterKit,
      TextStyle,                                   // <— aggiunto
      Color.configure({ types: ['textStyle'] }),   // <— aggiunto
      Underline,
      Heading.configure({ levels: [1, 2, 3] }),
    ],
    content: field.value || '<p>Inizia a scrivere...</p>',
    onUpdate({ editor }) {
      if (field.onChange) {
        field.onChange({
          target: {
            name: field.name,
            value: editor.getHTML(),
          },
        });
      }
    },
  })

  if (!editor) return null

  const buttons = [
    { label: 'H1', action: () => editor.chain().focus().toggleHeading({ level: 1 }).run(), active: () => editor.isActive('heading', { level: 1 }) },
    { label: 'H2', action: () => editor.chain().focus().toggleHeading({ level: 2 }).run(), active: () => editor.isActive('heading', { level: 2 }) },
    { label: 'Bold', action: () => editor.chain().focus().toggleBold().run(), active: () => editor.isActive('bold') },
    { label: 'Italic', action: () => editor.chain().focus().toggleItalic().run(), active: () => editor.isActive('italic') },
  ]

  return (
    <div className="ckeditor">
      {!field.disabled && 
        <div className="ck-buttons">
          {buttons.map((btn, i) => (
            <button
              key={i}
              onClick={btn.action}
              className={`icon-button ${btn.active && btn.active() ? 'active' : ''}`}
            >
              {btn.label}
            </button>
          ))}
          <input
            type="color"
            title="Colore testo"
            onChange={e => editor.chain().focus().setColor(e.target.value).run()}
            className="icon-button color-picker"
          />
        </div>}

      <div className="ck-content">
        <EditorContent editor={editor} />
      </div>
    </div>
  )
}
